import { useEffect, useState } from 'react'
import userService from '../services/userService'

export default function useMondaySettings(sessionToken, user, monday) {
  const [isNotifications, setIsNotifications] = useState(false)
  const [isShowCurrWorkspace, setIsShowCurrWorkspace] = useState(false)

  useEffect(() => {
    if (user && sessionToken) {
      userService.updateNotifications(user?.userId, isNotifications, sessionToken)
    }
  }, [sessionToken, user, isNotifications])

  useEffect(() => {
    monday.listen('settings', async (res) => {
      try {
        setIsNotifications(res.data.isNotifications)
        setIsShowCurrWorkspace(res.data.isShowCurrWorkspace)
      } catch (err) {
        console.log('file: useMondaySettings.jsx:20 -> err:', err)
      }
    })
  }, [])

  return { isShowCurrWorkspace }
}
